<template>
    <v-select
        v-model="selectedUser"
        label="email"
        placeholder="Search..."
        :options="users"
        @search="onSearch"
    >
        <template slot="no-options">
            Start typing to search for a user
        </template>
    </v-select>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: null
        }
    },

    data() {
        return {
            selectedUser: null,
            users: []
        };
    },

    watch: {
        selectedUser() {
            this.$emit('input', this.selectedUser || null);
        }
    },

    async created() {
        const id = this.value?.id;

        if (!id) {
            return;
        }

        try {
            this.selectedUser = await this.getUser(id);

            this.users.push(this.selectedUser);
        } catch (error) {
            console.error(error);
        }
    },

    methods: {
        ...mapActions({
            getUsers: 'users/index',
            getUser: 'users/show'
        }),

        async onSearch(search, loading) {
            if (!search) {
                this.users = this.selectedUser ? [this.selectedUser] : [];

                return;
            }

            loading(true);

            try {
                const { rows: users } = await this.getUsers({
                    search
                });

                if (
                    this.selectedUser &&
                    users.every(user => user.id !== this.selectedUser.id)
                ) {
                    users.push(this.selectedUser);
                }

                this.users = users;
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }

            loading(false);
        }
    }
};
</script>
